<template>
  <div :class="$style.container">
    <div :class="$style.logo">
      <logo-large />
    </div>

    <div :class="$style.information">
      <h5>{{ $t('registration.currency.info.title') }}</h5>
      <p>{{ $t('registration.currency.info.message') }}</p>
      <p>{{ $t('registration.currency.info.notice') }}</p>
    </div>
  </div>
</template>

<script>
import LogoLarge from 'atoms/logos/LogoLarge';

export default {
  name: 'ResidencyPoster',
  components: {
    LogoLarge,
  },
};
</script>

<style lang="sass" module>
  .container
    width: 310px
    display: flex
    flex-direction: column

  .logo
    margin-right: 110px
    display: flex

    svg
      width: 100%
      height: 100%

  .information
    margin-top: 50px
    padding-right: 30px

    h5
      margin-bottom: 20px
      font-weight: 700
      font-size: 14px
      line-height: 20px
      color: rgba(255, 255, 255, .75)

    p
      font-weight: 400
      font-size: 14px
      line-height: 20px
      color: rgba(255, 255, 255, .75)

      &:not(:last-child)
        margin: 0 0 20px
</style>
